<template>
  <!-- Curso -->
  <div class="col">
    <div class="form-group required">
      <ValidationProvider
        name="course_offered_id"
        rules="required"
        v-slot="{ valid, errors }"
      >
        <label class="control-label" for="course_offered_id">Curso</label>
        <b-form-select v-model="courseOfferedId" id="course_offered" size="sm">
          <template #first>
            <b-form-select-option value="null" disabled>
              {{ textSelectCourseOffered }}
            </b-form-select-option>
          </template>

          <b-form-select-option
            v-for="option in courseOfferedOptions"
            :key="option.id"
            :value="option.id"
            :style="
              option.registration ? 'background: #4caf50;color:#fff;' : ''
            "
            :title="
              option.grade_id == 0
                ? 'No tiene nota'
                : `Nota:${option.grade_final_grade}`
            "
          >
            {{ option.name }}
          </b-form-select-option>
        </b-form-select>
        <b-form-invalid-feedback :state="valid">{{
          errors[0]
        }}</b-form-invalid-feedback>
      </ValidationProvider>
      <small v-if="data !== null && changeParallel == false">
        <b
          >Profesor:{{
            data.person_fullname == " "
              ? "--Sin asignar--"
              : data.person_fullname
          }}
          | Inscritos: {{ data.total_students }}</b
        >
      </small>
      <small v-if="data !== null && changeParallel == true">
        <b>Paralelo:</b>
        {{ data.parallel == "NONE" ? "NINGUNO" : data.parallel }} |
        <b>Profesor:</b>
        {{
          data.person_fullname == " " ? "--Sin asignar--" : data.person_fullname
        }}
        | <b>Inscritos:</b> {{ data.total_students }}
      </small>
    </div>
  </div>
</template>
<script>
import {
  BFormInvalidFeedback,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";
import { Utils } from "@/plugins/utils";
import { extend } from "vee-validate";
import { required, max } from "vee-validate/dist/rules";
//services
import CoursesOffered from "@/plugins/services/courses-offered";

export default {
  name: "StudentCourseOffered",
  components: { BFormInvalidFeedback, BFormSelect, BFormSelectOption },
  props: {
    syllabus_id: { type: Number, default: null },
    period: { type: Number, default: null },
    course_id: { type: Number, default: null },
    value: { type: Number, default: null },
    changeParallel: { type: Boolean, default: false },
    year: { type: Number, default: null },
    student_id: { type: Number, default: null },
  },
  data() {
    return {
      courseOfferedId: null,
      yearData: null,
      addLoader: false,
      courseOfferedOptions: [],
      courseOfferedStudentOptions: [],
      dataEmit: { data: null },
      data: null,
      initialEdit: true,
      render: false,
    };
  },
  computed: {
    computedForm() {
      return this.$refs.form;
    },
    userAuth() {
      return this.$store.state.userAuth;
    },
    textSelectCourseOffered() {
      return this.courseOfferedOptions.length > 0
        ? "--Seleccione un curso--"
        : "--No existen cursos--";
    },
  },
  created() {
    extend("required", {
      ...required,
      message: "Este campo es requerido",
    });
  },
  mounted() {
    this.courseOfferedId = this.value;
    this.yearData =
      this.year == null ? Utils.getYear(this.userAuth.now) : this.year;
    if (this.syllabus_id && this.period && this.yearData)
      this.getCourseOffered();
  },
  watch: {
    syllabus_id(syllabus_id) {
      if (syllabus_id) this.getCourseOffered();
    },
    period(period) {
      if (period) this.getCourseOffered();
    },
    year(year) {
      this.yearData = year;
      if (this.syllabus_id && this.period && this.yearData)
        this.getCourseOffered();
    },
    courseOfferedId(id) {
      this.search(id);
    },
  },
  methods: {
    getCourseOffered() {
      // this.courseOfferedId = null;
      this.data = null;
      CoursesOffered.selectAllCourses({
        courses_offered_year: this.yearData,
        period: this.period,
        syllabus_id: this.syllabus_id,
        course_id: this.course_id,
      })
        .then((res) => {
          this.courseOfferedOptions = res.data;
          // si la no existen opciones y el valor inicial es
          if (this.courseOfferedOptions.length == 0 || this.value == null) {
            this.courseOfferedId = null;
          }
          if (this.value && this.initialEdit == true) {
            this.initialEdit = false;
            this.search(this.courseOfferedId);
          }
          this.getCourseOfferedStudent();
        })
        .catch((err) => {
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Curso ofertado no encontrado.");
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
          }
        });
    },
    getCourseOfferedStudent() {
      CoursesOffered.selectAllCoursesStudent({
        syllabus_id: this.syllabus_id,
        student_id: this.student_id,
        registration_annulled: false,
      })
        .then((res) => {
          this.courseOfferedStudentOptions = res.data;
          this.paintRegistration();
        })
        .catch((err) => {
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Curso ofertado no encontrado.");
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
          }
        });
    },
    paintRegistration() {
      // this.render = false;
      this.courseOfferedStudentOptions.map((courseOfferedStudent) => {
        let index = this.courseOfferedOptions.findIndex(
          (cOffered) => cOffered.course_id == courseOfferedStudent.course_id
        );
        let indexes = this.courseOfferedOptions.reduce(
          (arr, e, i) => (
            e.course_id == courseOfferedStudent.course_id && arr.push(i), arr
          ),
          []
        );
        indexes.map((i) => {
          this.courseOfferedOptions[i].grade_id = courseOfferedStudent.grade_id;
          this.courseOfferedOptions[i].grade_final_grade =
            courseOfferedStudent.grade_final_grade;
          this.courseOfferedOptions[i].style = "background: #f44336;";
          this.courseOfferedOptions[i].registration = true;
        });
      });
      // this.render = true;
    },
    search(id) {
      let course_offered = this.courseOfferedOptions.find((co) => co.id == id);
      this.data = course_offered ? course_offered : null;
      this.dataEmit.data = this.data;
      this.$emit("course_offered", this.dataEmit);
    },
  },
};
</script>
